import React from 'react';
import StatsShowcaseBase from '../../components/CountupWrapper/Count';

const StatsShowcase = () => {
  return (
    <StatsShowcaseBase
      title="המציאות של הלקוחות שלי אחרי ההיכרות איתי"
      highlightedWord="איתי"
      subtitle="ואיך בא לידי ביטוי השינוי של מי שבחר לצאת איתי לתהליך שיווקי"
      stats={[
        {
          value: "50%",
          label: "יותר סגירות של לידים",
          description: "כשהלקוח מגיע לשיחה כשהוא מכיר אתכן, השיחה יותר קלה"
        },
        {
          value: "20+",
          label: "שעות של חופש",
          description: "כי אני דואגת לכם לשיווק שעובד בשבילכן"
        },
        {
          value: "50K+",
          label: "חשיפות חדשות",
          description: "כשהשיווק עובד מגיעים לקהל חדש שצופה בכן"
        },
        {
          value: "300%",
          label: "עלייה בפניות",
          description: "שעובדים עם אסטרטגיה מדוייקת אנשים מתעניינים בשירות שלכן"
        }
      ]}
    />
  );
};

export default StatsShowcase;
